// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Family } from './family';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Household extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  careCoordinatorId?: number;
  deaconId?: number;
  elderId?: number;
  name?: string;
  number!: number;
  careCoordinator!: Person;
  deacon!: Person;
  elder!: Person;
  families!: Family[];
}

